<input
  type="text"
  id="{{ 'question-input-' + question.id }}"
  [formControl]="myFormControl"
  hidden
  class="hidden"
/>
<input
  #inputEl
  type="file"
  class="hidden"
  (change)="initFile($event.target['files'])"
  [attr.tabindex]="tabIndex"
/>
@if (filename) {
<div class="value" appTooltip [content]="tags">
  <p>{{ filename }}</p>
</div>
}
<div class="file-field-actions">
  @if (!filename) {
  <div
    class="ui primary button"
    [class]="{ disabled: disabled }"
    (click)="inputEl.click()"
  >
    {{ "upload-file" | transloco }}
  </div>
  } @if (filename) {
  <div
    class="ui primary button"
    [class]="{ disabled: disabled }"
    (click)="downloadFile()"
  >
    {{ "download-file" | transloco }}
  </div>
  } @if (filename) {
  <div>
    <div
      class="ui button"
      (click)="removeFile()"
      [class]="{ disabled: lockOnlyDisabledValue }"
    >
      {{ "remove-file" | transloco }}
    </div>
  </div>
  }
</div>
@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question.question }} {{ "is-required" | transloco }}</div>
  }
</div>
} @if (status === 'Uploading') {
<div>
  {{ "uploading-file" | transloco
  }}<i class="inline circle notch icon loading"></i>
</div>
} @if (!!errorMessage) {
<div class="clear validation-text">
  {{ errorMessage }}
</div>
}

<div #modal class="ui tiny modal" id="upload-modal">
  <div class="icon modal-close close"></div>
  <div
    class="icon"
    [ngClass]="{
      'green-success': modalMessage?.success,
      'red-error': modalMessage?.error
    }"
  ></div>

  <div class="content">
    @if (modalMessage?.error) {
    <h3>
      {{ "incorrect-file-setup" | transloco }}
    </h3>
    } @if (modalMessage?.error) {
    <p>{{ modalMessage?.error?.message }}</p>
    }
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>
